
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vote",
      function () {
        return require("private-next-pages/vote/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vote"])
      });
    }
  